import ROUTES from 'library/constants/routes';

export const logout = (history) => {
  localStorage.setItem('colormylife-token', '');

  history.push(ROUTES.LOGIN);
};
